import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_coffee: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-coffee" {...rest}>
      <title>praise-coffee</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#9AC3FF"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path
        fill="#D1423B"
        d="M77.5 112.9H61c-12.4 0-22.4-10-22.4-22.4V44.2c0-2.5 2-4.5 4.5-4.5h52.3c2.5 0 4.5 2 4.5 4.5v46.2c0 12.5-10 22.5-22.4 22.5z"
      ></path>
      <path
        fill="#D1423B"
        d="M97.1 93.8v-7.3c1.3 0 6.3-.9 16.9-13 2.5-2.8 2.5-6.9.2-9.9-2.3-2.8-6.1-3.7-9.4-2.1l-5.3 2.6-3.2-6.6 5.3-2.6c6.4-3.1 13.9-1.4 18.3 4.1 4.6 5.7 4.4 13.8-.4 19.3-9.2 10.5-16.5 15.5-22.4 15.5z"
      ></path>
      <path fill="#FB7F78" d="M95.5 39.8H42.9c-2.4 0-4.3 1.9-4.3 4.3v11.6h61.2V44.1c0-2.4-1.9-4.3-4.3-4.3z"></path>
    </svg>
  );
};
